import { formatISO } from 'date-fns'
import { TZDate } from '@date-fns/tz'

import {
  AuthorRole,
  GenerateAssistantChatMessagePayload,
  Message,
  MessageModel,
} from 'lib/apiClient'

interface CreateAssistantChatGenerationPayloadProps {
  text: string
  id: string
  previousDialogSnapshotId: string | null
  latestAssistantChatMessage: Message | null
  authorName: string
  chatMessages: Message[]
}

export const createAssistantChatGenerationPayload = ({
  text,
  id,
  previousDialogSnapshotId,
  latestAssistantChatMessage,
  authorName,
  chatMessages,
}: CreateAssistantChatGenerationPayloadProps): GenerateAssistantChatMessagePayload => {
  const messages: MessageModel[] = []

  const lastMessage =
    chatMessages.length > 0 ? chatMessages[chatMessages.length - 1] : null
  const isLastMessageFromAssistant = lastMessage?.authorRole === AuthorRole.Agent

  if (latestAssistantChatMessage && isLastMessageFromAssistant) {
    messages.push({
      messageId: latestAssistantChatMessage.messageId,
      authorRole: AuthorRole.Agent,
      payload: {
        type: 'text',
        value: latestAssistantChatMessage.text,
      },
      created: latestAssistantChatMessage.created,
    })
  }

  messages.push({
    messageId: id,
    authorRole: AuthorRole.Customer,
    authorName,
    payload: {
      type: 'text',
      value: text,
    },
    created: formatISO(TZDate.tz('UTC')),
  })

  return {
    previousDialogueSnapshotId: previousDialogSnapshotId,
    correlationId: id,
    messages,
  } as GenerateAssistantChatMessagePayload
}
